import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import RevenueLandingPage from './pages/RevenueLandingPage';
import RevenueLandingPage_Intl from './pages/RevenueLandingPage_Intl';
import BookingPage from './pages/BookingPage';
import AdminPanel from './pages/AdminPanel';
import ThankYouPage from './pages/ThankYouPage';
import SoftwareRejectionThankYou from './pages/SoftwareRejectionThankYou';
import useMetaPixel from './hooks/useMetaPixel';
import { ModalProvider } from './contexts/ModalContext';
import GlobalModals from './components/GlobalModals';
import WebinarLandingPage from './pages/WebinarLandingPage';

function App() {
  useMetaPixel();
  return (
    <ModalProvider>
      <ScrollToTop />
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/revenue" element={<RevenueLandingPage />} />
          <Route path="/revenue_intl" element={<RevenueLandingPage_Intl />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/software-rejection" element={<SoftwareRejectionThankYou />} />
          <Route path="/webinar" element={<WebinarLandingPage />} />
        </Routes>
      </div>
      <GlobalModals />
    </ModalProvider>
  );
}

export default App;